import React from 'react';

import { AppleIcon } from '../../assets/svg/appleIcon';
import { Button } from '../button';

import './ApplePayButton.css';

export const ApplePayButton = ({ onClick }: { onClick: () => void }) => (
	<Button
		className="apple-pay-button"
		data-pp-at-target="Apple Pay"
		label={<AppleIcon width={47} />}
		type="button"
		onClick={onClick}
	/>
);
